import { ACTION_TYPES } from "../../consts";
import { runInAction } from "mobx";
import { BettingPromotionBaseHandler } from "./betting-promotion.base.handler";
import { POPUP_DISPLAY } from "../../models/popup/consts";
import {PopupsDisplayManager} from "../../managers/popups-display.manager";
import {LocalStorageUtils} from "../../../infrastructure/utils/local-storage.utils";

export class BettingPromotionModuleDisplayHandler extends BettingPromotionBaseHandler {
  type = ACTION_TYPES.bettingPromotionDisplay;
  static injectables = [...BettingPromotionBaseHandler.injectables, PopupsDisplayManager];

  constructor(localStorageUtils: LocalStorageUtils, popupsDisplayManager: PopupsDisplayManager) {
    super(localStorageUtils);

    this.popupsDisplayManager = popupsDisplayManager;
  }

  action(params) {
    const callback = function () {
      const isValidBookie = this.model?.remoteConfigModel.currentBookie?.visible;
      const isVisible = isValidBookie && params.isVisible;

      this.model.isVisible = isVisible;

      if (isVisible) {
        this.model.localStorageModel.populateVisible();
        this.updateLocalStorageModel();
      }

      this.popupsDisplayManager.setPopupDisplayStatus(POPUP_DISPLAY.AUTO_DISPLAY_POPUPS.bp, isVisible)

    }.bind(this);

    runInAction(callback);
  }
}
